module.exports = __webpack_public_path__ + "img/app-ui.282b0362.png";